import { imageUrl } from "config/apiUrl";
import { User } from "constant/imagePath";
import { IoCaretBackOutline, IoNotificationsOutline } from "react-icons/io5";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import Classes from "./AfterLoginHeader.module.css";

export const AfterLoginHeader = ({ header, drawerBtn, isCollapsed, icon }) => {
  const { user } = useSelector((state) => state?.authReducer);
  const { unReadNotificationCount } = useSelector(
    (state) => state?.commonReducer
  );
  const path = useLocation().pathname;
  const splitPath = path.split("/");
  const navigate = useNavigate();

  return (
    <div className={Classes.navbarContainer}>
      {drawerBtn && drawerBtn}
      <div className={Classes.mainHeader}>
        {splitPath.length > 2 && (
          <div className={Classes.backBtn} onClick={() => navigate(-1)}>
            <IoCaretBackOutline />
          </div>
        )}
        {header && <h1 className={Classes.heading}>{header}</h1>}
        {icon && <span className={Classes.iconStyle}>{icon}</span>}
      </div>
      <div
        className={Classes.notification_header}
        onClick={() => navigate("/notifications")}
      >
        {unReadNotificationCount > 0 && (
          <div className={Classes.unseen}>
            <span>{unReadNotificationCount}</span>
          </div>
        )}
        <IoNotificationsOutline />
      </div>
      <div className={`${[Classes.profileImg]} `}>
        <img src={user ? imageUrl(user?.photo) : User} alt="profile" />
      </div>
    </div>
  );
};
